import React from 'react'
import moment from 'moment'
import { IRadioOption } from 'transfix-form/components/ControlledRadioGroupInput'
import { Box } from 'transfix-ui/core'

export enum DispatcherScope {
  allDispatchers = 'allDispatchers',
  specificDispatchers = 'specificDispatchers',
}

export enum EquipmentType {
  any = 'any',
  dryVan = 'dry_van',
  reefer = 'reefer',
  openDeck = 'open_deck',
}

export interface SubscribedDispatcher {
  id: string
  name: string
  email?: string
  type?: string
}

export interface ICarrierObjectAddLaneModal {
  id: number
  name: string
}

export enum DropoffPreference {
  localHaul = '100',
  shortHaul = '100-300',
  longHaul = '300+',
  specificLocation = 'specific-location',
}

export const TODAY = moment().toDate()

export const trailerTypeOptions: IRadioOption[] = [
  { id: EquipmentType.any, label: 'Any Equipment' },
  { id: EquipmentType.dryVan, label: 'Dry Van only' },
  { id: EquipmentType.reefer, label: 'Reefer only' },
  { id: EquipmentType.openDeck, label: 'Flatbed only' },
]

export const dispatcherScopeOptions: IRadioOption[] = [
  {
    id: DispatcherScope.allDispatchers,
    label: (
      <Box mb={1}>
        <Box className='b'>Everyone</Box>
        <Box>Every Dispatcher or Owner Operator will be alerted.</Box>
      </Box>
    ),
  },
  {
    id: DispatcherScope.specificDispatchers,
    label: (
      <Box mb={1}>
        <Box className='b'>Specific people</Box>
        <Box>Select which Dispatchers or Owner Operators should be alerted.</Box>
      </Box>
    ),
  },
]

export const stopRadii = [
  { value: 1, label: '1mi' },
  { value: 25, label: '25mi' },
  { value: 50, label: '50mi' },
  { value: 75, label: '75mi' },
  { value: 100, label: '100mi' },
  { value: 150, label: '150mi' },
  { value: 200, label: '200mi' },
]

export const daysOfWeek = [
  'Mondays',
  'Tuesdays',
  'Wednesdays',
  'Thursdays',
  'Fridays',
  'Satudays',
  'Sundays',
]
